// Customer auth — separate from internal AuthContext.
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = "govbidiq_customer_session";

const Ctx = createContext(null);
export const useCustomerAuth = () => useContext(Ctx);

const custApi = axios.create({ baseURL: `${BASE}/api`, withCredentials: false });
custApi.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem(STORAGE_KEY);
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const tok = localStorage.getItem(STORAGE_KEY);
    if (!tok) { setCustomer(null); setLoading(false); return; }
    try {
      const r = await custApi.get("/customer/me");
      setCustomer(r.data);
    } catch {
      localStorage.removeItem(STORAGE_KEY);
      setCustomer(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = async () => {
    try { await custApi.post("/customer/logout"); } catch {}
    localStorage.removeItem(STORAGE_KEY);
    setCustomer(null);
  };
  const loginWithSession = (session_token, customer) => {
    localStorage.setItem(STORAGE_KEY, session_token);
    setCustomer(customer);
  };

  return <Ctx.Provider value={{ customer, loading, refresh, logout, loginWithSession, custApi }}>{children}</Ctx.Provider>;
}
